<template>
  <el-container>
    <!-- 主体内容 -->
    <el-header
      style="display: flex; align-items: center; justify-content: space-between"
    >
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>补充答复佐证列表</el-breadcrumb-item>
      </el-breadcrumb>
    </el-header>
    <el-main>
      <div>
        <!-- 查询工具栏-->
        <div class="cust_seach">
          <el-select
            v-model="query.pstType"
            placeholder="请选择"
            class="btnLeft"
          >
            <el-option
              v-for="pstType in pstApi.pstTypes"
              :key="pstType.value"
              :label="pstType.title"
              :value="pstType.value"
            >
            </el-option>
          </el-select>
          <el-input
            class="btnTitle"
            v-model="query.queryString"
            placeholder="请输入模糊字段"
          />

          <el-button-group>
            <el-button
              type="primary"
              icon="el-icon-search"
              @click="querySubmit"
            />
          </el-button-group>
        </div>
        <el-table :data="data.psts">
          <el-table-column prop="postingTime" label="发贴时间" width="100" align="center">
            <template slot-scope="scope">
              <div>
                {{ Common.dateFormatter(scope.row.postingTime, "yyyy-MM-dd") }}
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="name" label="发贴人" width="150"  align="center"/>
          <el-table-column prop="title" label="标题">
            <template slot-scope="scope">
              <div>
                <el-button type="text" size="small" @click="details(scope.row)">
                  {{ scope.row.title }}
                </el-button>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="pstSource" label="舆情来源" width="120" align="center">
            <template slot-scope="scope">
              <div>
                <a :href="scope.row.pstUrl" target="_blank">{{
                  scope.row.pstSource
                }}</a>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="lastTime" label="办理时间" width="150" align="center">
            <template slot-scope="scope">
              <span>
                {{ Common.dateFormatter(scope.row.lastTime, "yyyy-MM-dd hh:mm") }}
              </span>
            </template>
          </el-table-column>
          <el-table-column prop="status" label="状态" width="80">
            <template slot-scope="scope">
              <el-tag :type="'success'" disable-transitions>{{
                pstApi.getStatusTransferTitle(scope.row.status)
              }}</el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="status" width="60" fixed="right" label="操作" align="center">
            <template slot-scope="scope">
              <el-button type="text" size="small" @click="handle(scope.row)">
                佐证
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="cust_pagin">
          <el-pagination
            layout="prev, pager, next"
            :total="xpagination.totalCount"
            :page-size="xpagination.pageSize"
            :current-page="xpagination.pageNumber"
            @current-change="handleCurrentChange"
            hide-on-single-page
            :background="true"
          />
        </div>
      </div>
    </el-main>
  </el-container>
</template>
  
<script>
import { Loading } from "element-ui";
export default {
  created() {
    this.getPstList(); //读取分页信息
  },
  data() {
    return {
      //数据项
      data: {
        psts: [], //舆情信息
      },
      //搜索栏数据
      query: {
        pstType: -1, //类别
        queryString: "", //模糊字段
      },
      //分页栏数据
      xpagination: {
        totalCount: 1,
        pageSize: 10,
        pageNumber: 1,
        totalPages: 1,
      },
    };
  },
  methods: {
    querySubmit() {
      this.getPstList();
    },
    getPstList() {
      this.pstApi
        .getEvidentcePstList(
          this.query.pstType,
          this.query.queryString,
          this.xpagination.pageNumber,
          this.xpagination.pageSize
        )
        .then((res) => {
          var data = res.data;
          this.data.psts = data;
          //console.log(data);
          var pagin = JSON.parse(res.headers.xpagination);
          //console.log(pagin)
          this.xpagination.totalCount = parseInt(pagin.totalCount);
          this.xpagination.pageSize = parseInt(pagin.pageSize);
          this.xpagination.pageNumber = parseInt(pagin.currentPage);
          this.xpagination.totalPages = parseInt(pagin.totalPages);
        })
        .catch(() => {
          Toast("读取失败");
        });
    },
    //分页操作
    handleCurrentChange(val) {
      this.xpagination.pageNumber = val;
      this.getPstList();
    },
    details(pst) {
      this.$router.push({ name: "HandleDetail", params: { id: pst.id } });
    },
    handle(pst) {
      this.$router.push({ name: "Evidence", params: { id: pst.id } });
    },
  },
};
</script>
  
<style lang="less" scoped>
.el-header {
  background-color: #b3c0d1;
  color: #333;
  line-height: 40px;
}
//工具栏样式
.cust_seach {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 50px;
  width: 100%;
  padding: auto 5px;
  .btnLeft {
    flex: 1;
    margin: 0;
    /deep/ .el-input__inner {
      height: 41px;
      border-radius: 0px;
      border-top-left-radius: 4px;
      border-bottom-left-radius: 4px;
    }
  }
  .btnTitle {
    flex: 2;
    margin: 0;
    /deep/ .el-input__inner {
      height: 41px;
      border-radius: 0px;
      border-top-left-radius: 0px;
      border-bottom-left-radius: 0px;
    }
  }
  .btnStatus {
    flex: 1;
    margin: 0;
    /deep/ .el-input__inner {
      height: 41px;
      border-radius: 0px;
      border-top-right-radius: 0px;
      border-bottom-right-radius: 0px;
    }
  }
  .el-button-group > .el-button:first-child:last-child {
    border-radius: 0px;
    border-top-right-radius: 4px;
    border-bottom-right-radius: 4px;
  }
}
.el-select {
  float: left;
}
.cust_pagin {
  display: flex;
  position: sticky;
  bottom: 0;
  z-index: 999;
}
/deep/.el-breadcrumb__separator {
  color: rgb(87, 86, 86);
}
</style>